import QRCode from './qr-code'
export * from './qr-code'
export default QRCode
